import { createContext, useContext } from 'react';

export const TaskAllocationEditorContext = createContext();

export const useTaskAllocationEditorContext = () =>
  useContext(TaskAllocationEditorContext);

export default TaskAllocationEditorContext;
